export default __webpack_public_path__ + "static/media/HeaderCurveDesignP24.e2ccf48e.png";